import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { get_payment_request_details } from "../../DAL/PaymentRequest/paymentRequest";
import CircularLoader from "../../components/loader/CircularLoader";
import { enqueueSnackbar } from "notistack";
import PaymentSuccessCard from "./PaymentSuccessCard";

export default function PaymentThanksPage() {
  const { state } = useLocation();
  const params = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [paymentRequestDetails, setPaymentRequestDetails] = useState();

  const getRequestDetail = async () => {
    const result = await get_payment_request_details(params.id);
    if (result.code === 200) {
      setPaymentRequestDetails(result.payment_request);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  function calculateChargeableAmount(name = "initial_amount") {
    let baseAmount = 0;

    if (paymentRequestDetails.plan.payment_access === "onetime") {
      baseAmount = paymentRequestDetails.plan.total_amount;
    } else if (paymentRequestDetails.plan.payment_access === "recursion") {
      baseAmount = paymentRequestDetails.plan[name];
    }

    if (baseAmount <= 0) return 0;

    const vatAmount =
      paymentRequestDetails.plan.vat_percentage > 0
        ? (baseAmount * paymentRequestDetails.plan.vat_percentage) / 100
        : 0;

    const chargeableAmount = baseAmount + vatAmount;

    return parseFloat(chargeableAmount.toFixed(2));
  }

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const promises = [];

        if (!state) {
          promises.push(getRequestDetail()); // run only if state is not provided
        } else {
          setPaymentRequestDetails(state); // use state directly
        }

        await Promise.all(promises); // wait for all
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <CircularLoader />;
  }

  return (
    <>
      <PaymentSuccessCard
        amount={calculateChargeableAmount()}
        paymentRequestDetails={paymentRequestDetails}
        currency={paymentRequestDetails.plan.plan_currency}
        onClose={() => navigate("/payment-requests")}
      />
    </>
  );
}
